import { CSSProperties, FC, ReactNode } from 'react';
import getClassNames from 'src/common/utils/getClassNames';
import styles from './SkeletonLoader.module.scss';

export type SkeletonLoaderProps = {
  gap?: number;
  width?: CSSProperties['width'];
  children: ReactNode;
};

const SkeletonLoader: FC<SkeletonLoaderProps> = ({
  gap = 1,
  width = '',
  children,
}) => (
  <div
    className={getClassNames(styles, 'root', `gap${gap}`)}
    style={{
      '--width': width,
    } as CSSProperties}
  >
    {children}
  </div>
);

export default SkeletonLoader;
